import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-line',
  templateUrl: './new-line.component.html',
  styleUrls: ['./new-line.component.scss']
})
export class NewLineComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
